// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmVideoPromo = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			activeClass: 'promo--video-active',
			feature: '.feature-button--top-right',
			featureActive: 'feature-button--top-right-active'
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// Toggle Active Classes
		methods.toggle = function ($context) {
			// Remove and then add the video again (in case it is playing)
			if ($context.hasClass(settings.activeClass)) {
				$context.append($context.find('.promo__video').clone()).html();
				$context.find('.promo__video')[0].remove();
			}
			// Toggle active classes
			$context.toggleClass(settings.activeClass);
			$context.next(settings.feature).toggleClass(settings.featureActive);


		}

		// Bind events
		methods.events = function($context) {
			$context.off('click.lmVideoPromo').on('click.lmVideoPromo', function(event) {
				event.preventDefault();
				methods.toggle($context);
			});

			$context.next(settings.feature).off('click.lmVideoPromo').on('click.lmVideoPromo', function(event) {
				event.preventDefault();
				methods.toggle($context);
			});
		}

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Run once methods when jquery plugin is called.
		methods.events(this);

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));
		});
	};

	if($('.promo--video').length) {
		$('.promo--video').lmVideoPromo();
	}

}(jQuery));